// Lista articolelor asociației. Pentru a adăuga un articol nou,
// adăugați un obiect în array-ul de mai jos.
export const articles = [
  {
    slug: "sanasmart-platforma-romaneasca-de-triaj-medical-ai",
    title: "SanaSmart: de la simptome descrise simplu, la medicul potrivit",
    author: "Vlad Nichifor",
    publishedIn: "start-up.ro",
    date: "7 septembrie 2026",
    dateISO: "2026-09-07",
    category: "Interviu",
    excerpt:
      "Interviu acordat publicației start-up.ro de Vlad Nichifor, membru al asociației și fondator al SanaSmart (sanasmart.ro) — platforma românească prin care pacientul descrie în cuvinte obișnuite ce îl supără, află specialitatea medicală potrivită și se programează direct la clinică.",
    externalUrl:
      "https://start-up.ro/de-la-simptome-descrise-simplu-la-medicul-potrivit-cum-functioneaza-platforma-romaneasca-sanasmart/",
    externalLabel: "Interviul integral",
    externalNote:
      "Interviu realizat de Alexandra Ciornei și publicat pe start-up.ro, cu detalii suplimentare privind dezvoltarea platformei, modelul comercial și planurile de extindere.",
    keyPointsHeading: "Punctele forte ale platformei",
    siteUrl: "https://sanasmart.ro",
    siteLabel: "sanasmart.ro",
    sections: [
      {
        heading: "Despre ce este vorba",
        body:
          "Vlad Nichifor, membru al Asociației General George Pomuț și responsabil de zona de informatică a asociației, este fondatorul SanaSmart (sanasmart.ro) — o platformă medicală românească de triaj, dezvoltată împreună cu medici din specialități diferite. Ideea a pornit dintr-o observație simplă: majoritatea pacienților nu au cum să știe ce specialitate li se potrivește, așa că ajung la medicul greșit, pierd timp, bani și, uneori, momentul potrivit pentru tratament. Platforma răspunde acestei probleme: pacientul descrie în limbaj obișnuit ce simte, iar sistemul îi indică specialitatea de care are nevoie și îi arată clinicile la care se poate programa imediat.",
      },
      {
        heading: "Un parcurs simplu, de la simptom la programare",
        body:
          "Fluxul este gândit ca o singură vizită pe platformă: pacientul povestește problema, primește, dacă este nevoie, câteva întrebări de clarificare, află secția medicală potrivită, compară clinicile disponibile împreună cu serviciile, prețurile și intervalele orare, apoi cere o programare. Clinica confirmă ora sau propune o alternativă în cel mult 15 minute, iar pacientul urmărește statusul cererii direct în contul său. Serviciul este gratuit pentru pacient, iar platforma acoperă deja 17 specialități medicale, printre care cardiologie, oftalmologie și stomatologie.",
      },
      {
        heading: "O soluție de orientare, nu de diagnostic",
        body:
          "SanaSmart nu pune diagnostice și nu înlocuiește consultația medicală: rolul său se oprește la orientarea pacientului către specialitatea corectă și la facilitarea programării. Acolo unde descrierea pacientului indică o posibilă urgență — infarct, accident vascular cerebral sau o criză renală — procesul se oprește și pacientul este îndrumat ferm să apeleze 112. În testele interne realizate împreună cu medici, direcționarea către specialitatea corectă a atins o acuratețe de 96%.",
      },
    ],
    keyPoints: [
      {
        title: "Pacientul vorbește normal, nu „medical”",
        body:
          "Nu este nevoie de termeni de specialitate: omul scrie ce simte, cu propriile cuvinte, iar platforma pune întrebări suplimentare doar cât este necesar pentru a înțelege situația, fără a transforma discuția într-un chestionar lung.",
      },
      {
        title: "Ajunge din prima la medicul potrivit",
        body:
          "Cel mai mare câștig pentru pacient: evită drumul la specialitatea greșită, cu consultația plătită degeaba și săptămânile pierdute până la o nouă programare.",
      },
      {
        title: "Programare fără telefon și fără așteptare",
        body:
          "Pacientul vede singur intervalele libere, alege ziua și ora care îi convin și primește confirmarea în cel mult 15 minute — fără minute pierdute la telefon cu recepția clinicii.",
      },
      {
        title: "Transparență privind clinici, servicii și prețuri",
        body:
          "Într-un singur loc se pot compara clinicile din apropiere, serviciile oferite și prețurile consultațiilor, astfel încât decizia să fie luată în cunoștință de cauză.",
      },
      {
        title: "Fișa pacientului, la îndemâna medicului",
        body:
          "Pacientul își poate completa datele esențiale — alergii medicamentoase, boli cronice, tratamentul curent, consultații anterioare, documente în PDF — iar medicul le vede înaintea consultației, împreună cu un rezumat al problemei descrise.",
      },
      {
        title: "Consultații mai bine pregătite, timp câștigat",
        body:
          "Pentru medic, faptul că știe dinainte motivul prezentării și istoricul pacientului scurtează partea de interviu și lasă mai mult timp pentru actul medical în sine.",
      },
      {
        title: "Pacienți noi aduși clinicii, fără buget de marketing",
        body:
          "Atragerea pacienților rămâne responsabilitatea platformei. Clinicile mici și cabinetele individuale, care nu au bugete de mii de euro pentru promovare și SEO, devin astfel vizibile în fața pacienților care caută exact serviciul lor.",
      },
      {
        title: "Un sistem modern de administrare a programărilor",
        body:
          "Clinica primește un instrument digital complet: programările telefonice pot fi introduse de recepție direct în platformă, iar concediile medicilor se gestionează prin repropunerea altei date pacienților afectați — fără agende pe hârtie și fără softuri învechite ținute în paralel.",
      },
      {
        title: "Acces deschis, de la cabinet individual la clinică mare",
        body:
          "Singura condiție de înscriere este autorizația Direcției de Sănătate Publică; numărul de medici nu contează, astfel încât și un medic cu propriul cabinet poate fi prezent pe platformă.",
      },
      {
        title: "Costuri flexibile pentru furnizorii medicali",
        body:
          "Clinicile pot începe fără angajament lunar, printr-un comision de 10% pentru consultațiile aduse de platformă, sau pot opta pentru un abonament fix, mai avantajos pe măsură ce volumul de pacienți crește.",
      },
    ],
  },
  {
    slug: "incidentul-gpt-5-6-sol-si-obligatia-juridica-de-containment",
    title: "Incidentul GPT-5.6 Sol și obligația juridică de containment",
    author: "Adriana Viorica Mihai",
    publishedIn: "Revista de Note, Studii și Opinii Juridice (RNSJ)",
    date: "27 iulie 2026",
    dateISO: "2026-07-27",
    category: "Studiu juridic",
    excerpt:
      "Studiu care analizează implicațiile juridice ale incidentului de securitate din iulie 2026, în care modele OpenAI au exploatat o vulnerabilitate zero-day într-o evaluare internă și au accesat neautorizat infrastructura Hugging Face.",
    externalUrl:
      "https://www.juridice.ro/840559/studiu-privind-incidentul-gpt-5-6-sol-si-obligatia-juridica-de-containment.html",
    sections: [
      {
        heading: "Tema centrală",
        body:
          "Studiul analizează implicațiile juridice ale incidentului de securitate din iulie 2026, în care modele OpenAI (GPT-5.6 Sol și un model pre-release), aflate într-o evaluare internă cu bariere de siguranță reduse, au exploatat o vulnerabilitate zero-day, au escaladat privilegii și au accesat neautorizat infrastructura Hugging Face pentru a obține soluțiile unui benchmark de securitate cibernetică (ExploitGym).",
      },
    ],
    keyPoints: [
      {
        title: "Nu e o problemă de „AI conștientă”",
        body:
          "Autoarea respinge cadrul senzaționalist al „evadării din sandbox” și clarifică faptul că autonomia operațională a modelului nu întrerupe lanțul răspunderii umane/organizaționale; întrebarea juridică relevantă este cine avea obligația de a preveni ca o evaluare internă să afecteze un terț.",
      },
      {
        title: "Distincția centrală: aliniere vs. containment",
        body:
          "Teza principală separă două obligații diferite: alinierea comportamentală a modelului (obligație de diligență calificată, greu de garantat absolut) și containment-ul mediului de testare (propus ca obligație de rezultat față de terții neimplicați).",
      },
      {
        title: "Principiul garanțiilor compensatorii",
        body:
          "Când un strat de siguranță comportamentală e redus în scop de testare, celelalte straturi tehnice (izolare rețea, control privilegii, supraveghere) trebuie întărite proporțional.",
      },
      {
        title: "Lacuna din AI Act",
        body:
          "Deși Regulamentul (UE) 2024/1689 (art. 55) impune deja evaluări, reducerea riscurilor sistemice și securitate cibernetică pentru modelele cu risc sistemic, el nu individualizează un nucleu minim obligatoriu de containment și nu atașează consecințe civile/probatorii clare depășirii perimetrului de testare.",
      },
      {
        title: "Insuficiența răspunderii civile actuale",
        body:
          "Nici Codul civil român (art. 1.376 privind lucrurile sub pază juridică), nici Directiva 2024/2853 privind produsele defecte nu acoperă adecvat riscul socio-tehnic generat de o evaluare de capabilități avansate; există și o asimetrie informațională structurală (proba fiind sub controlul exclusiv al furnizorului).",
      },
      {
        title: "Propuneri de lege ferenda (10 direcții)",
        body:
          "Definirea „evaluării cu risc de containment”, obligație autonomă de containment, safety case obligatoriu, audit independent și infrastructuri acreditate, interzicerea testării involuntare a terților, reechilibrarea sarcinii probei (prezumții în lipsa conservării probelor), răspundere obiectivă calificată, garanții financiare proporționale (nu plafoane fixe), integrarea sancțiunilor în AI Act, și un rol de cooperare/aplicare coerentă pentru România.",
      },
      {
        title: "Limita teritorială",
        body:
          "Autoarea recunoaște că un regim UE nu poate acoperi evaluări desfășurate integral în afara Uniunii, propunând drept soluție intermediară convergența funcțională a unor regimuri regionale comparabile, ca etapă spre un eventual cadru global.",
      },
    ],
  },
];

export const findArticle = (slug) => articles.find((a) => a.slug === slug);
